import api from "./api";

// A suite's run notifications (email, Slack, Teams). Webhook URLs are write-only: the
// settings say only whether one is configured; send null to keep it, "" to remove it.
const notificationService = {
	get: async (suiteId) => (await api.get(`/suites/${suiteId}/notifications`)).data,
	update: async (suiteId, settings) => (await api.put(`/suites/${suiteId}/notifications`, settings)).data,
	sendTest: async (suiteId) => (await api.post(`/suites/${suiteId}/notifications/test`)).data,
};

export default notificationService;
